'use client';
import React from 'react';
import * as Styled from './styled';

import { IRepositoryCompareEntry } from '@/lib/repositoryCompareApi';

const DirectoryFileTypeChangeSet: React.FC<{ entry: IRepositoryCompareEntry }> = ({ entry }) => {
  const basefileTypeCounts = entry.base_entry?.metadata?.dir?.data_types;
  const headfileTypeCounts = entry.head_entry?.metadata?.dir?.data_types;

  const base =
    basefileTypeCounts?.map((type) => ({
      data_type: type.data_type,
      head_count: 0,
      base_count: type.count,
    })) || [];
  const head =
    headfileTypeCounts?.map((type) => ({
      data_type: type.data_type,
      head_count: type.count,
      base_count: 0,
    })) || [];

  const baseFileDataTypes = base?.map((type) => type.data_type) || [];
  const headFileDataTypes = head?.map((type) => type.data_type) || [];

  const allDataTypes = [...new Set(baseFileDataTypes?.concat(headFileDataTypes))].filter(
    (type) => type !== 'directory',
  );

  const changeSet = allDataTypes.map((type) => {
    const baseCount = base.find((baseType) => baseType.data_type === type)?.base_count || 0;
    const headCount = head.find((headType) => headType.data_type === type)?.head_count || 0;
    return {
      data_type: type,
      base_count: baseCount,
      head_count: headCount,
      change: headCount - baseCount,
    };
  });

  if (changeSet.length === 0) {
    return null;
  }
  return (
    <Styled.DirectoryFileTypeChangeSet>
      <thead>
        <tr>
          <th>Data Type</th>
          <th className="number">Base</th>
          <th className="number">Head</th>
          <th className="number">Change</th>
        </tr>
      </thead>
      <tbody>
        {changeSet.map((change) => (
          <tr key={change.data_type}>
            <td>{change.data_type} files</td>
            <td className="number">{change.base_count}</td>
            <td className="number">{change.head_count}</td>
            <td className="number">
              {change.change > 0 ? '+' : change.change < 0 ? '-' : ''}
              {change.change}
            </td>
          </tr>
        ))}
      </tbody>
    </Styled.DirectoryFileTypeChangeSet>
  );
};

export default DirectoryFileTypeChangeSet;
